import React from 'react';
import Box from '@mui/material/Box';

export default function SmallHeading(props) {
    return (
        <Box sx={{ fontSize: '2em', marginTop: '7px', ...(props.sx || {}) }}
            onClick={props.onClick}>
            {props.children}</Box>
    )
}
